import FormControlLabel from '@mui/material/FormControlLabel'
import { Checkbox, Typography } from 'components/Material/index'
import useTextStyles from 'styles/useTextStyles'

type CheckboxProps = {
  name?: string
  label?: string
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  error?: boolean
  helperText?: string
  required?: boolean
  'data-testid'?: string
}

export const CheckboxComponent = ({
  name,
  label,
  checked,
  onChange,
  disabled,
  error,
  helperText,
  required,
  'data-testid': dataTestId
}: CheckboxProps) => {
  return (
    <div>
      <FormControlLabel
        className="w-full"
        control={
          <Checkbox
            checked={checked}
            onChange={onChange}
            name={name}
            color={error ? 'error' : 'primary'}
            disabled={disabled}
            required={required}
            data-testid={dataTestId}
            inputProps={{ 'aria-label': label }}
          />
        }
        label={
          <Typography
            title={label || ''}
            disabled={disabled}
            variant="body1"
            sx={useTextStyles.bodyLarge}
            color={error ? 'error' : 'inherit'}
          >
            {label}
            {required && !disabled && <span className="text-red-500 ml-1">*</span>}
          </Typography>
        }
        disabled={disabled}
      />
      {helperText && (
        <Typography variant="caption" sx={{ pl: 2 }} color={error ? 'error' : 'text.secondary'}>
          {helperText}
        </Typography>
      )}
    </div>
  )
}
